import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, c = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M9.944 6.055A1.75 1.75 0 1 0 7.47 8.53a1.75 1.75 0 0 0 2.474-2.475ZM8.53 7.116a.25.25 0 1 1 .354.354.25.25 0 0 1-.354-.354Z",
  "clip-rule": "evenodd"
}, null, -1), a = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M13.733 3.866a1.561 1.561 0 0 0-1.6-1.6c-2.083.046-4.273.995-6.003 2.392-.445.36-.867.754-1.252 1.178H2.343a.75.75 0 0 0-.53.22L.397 7.47a.75.75 0 0 0 .294 1.24l2.122.708a.757.757 0 0 0 .036.01 6.486 6.486 0 0 0-.14.731l-1.409.705a.75.75 0 0 0-.195 1.2l2.829 2.83a.75.75 0 0 0 1.2-.196l.705-1.409a6.485 6.485 0 0 0 .73-.14.786.786 0 0 0 .012.037l.707 2.121a.75.75 0 0 0 1.242.293l1.414-1.414a.75.75 0 0 0 .22-.53v-2.535c.424-.386.818-.807 1.178-1.253 1.397-1.73 2.345-3.919 2.391-6.003Zm-1.566-.1c.024 0 .038.007.049.018.01.01.018.025.018.049-.01.48-.082.976-.208 1.476l-1.335-1.336c.5-.125.996-.196 1.476-.207Zm-3.036.769 2.334 2.334c-.337.72-.774 1.419-1.29 2.058-1.224 1.515-2.812 2.597-4.4 2.859l-1.561-1.561c.261-1.589 1.343-3.177 2.858-4.4a10.14 10.14 0 0 1 2.059-1.29Zm-.467 7.717a8.444 8.444 0 0 1-.693.38.76.76 0 0 1 .033.08l.323.97.337-.336v-1.094Zm-6.01-4.916h1.094a8.47 8.47 0 0 0-.38.692.757.757 0 0 0-.081-.032l-.97-.324.336-.336Zm.248 4.405.471-.236 1.121 1.121-.236.472-1.356-1.357Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  c,
  a
];
function d(r, s) {
  return l(), o("svg", t, [...n]);
}
const m = { render: d };
export {
  m as default,
  d as render
};
